import { Injectable } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { CrudService } from './crud.service';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class SharedService {
  DraftStatus: string = "DRAFT";
  PendingwithManager: string = "PENDING WITH MANAGER APPROVAL";
  ApprovedbyManager: string = "APPROVED BY MANAGER";
  PendingwithSBU: string = "PENDING WITH SBU HEAD";
  RejectedBySBU: string = "REJECTED BY SBU HEAD";
  PendingwithCEO: string = "PENDING WITH FINANCE CONTROLLER";
  ApprovedbyCEO: string = "APPROVED BY FINANCE CONTROLLER";
  PendingwithAccounts: string = "PENDING WITH ACCOUNT APPROVAL";
  ProcessedbyAcocunts: string = "PROCESSED BY ACCOUNTS";
  ApprovedbyAccounts: string = "APPROVED BY ACCOUNTS";
  TransfertoBank: string = "TRANSFER TO BANK";
  RejectedByManager: string = "REJECTED BY MANAGER";
  RejectedByCEOApprover: string = "REJECTED BY FINANCE CONTROLLER";
  RejectedByAccounts: string = "REJECTED BY ACCOUNTS";
  HoldByAccounts: string = "HOLD BY ACCOUNTS";
  PendingwithRDH: string = "PENDING WITH RDH";
  ApprovedbyRDH: string = "APPROVED BY RDH";
  RejectedByRDH: string = "REJECTED BY RDH";
  PendingwithDeliveryHead: string = "PENDING WITH DELIVERY HEAD";
  ApprovedbyDeliveryHead: string = "APPROVED BY DELIVERY HEAD";
  RejectedByDeliveryHead: string = "REJECTED BY DELIVERY HEAD";

  TCPL: String = "Team Computers Pvt.Ltd.";
  Kockpit: string = "Kockpit Analytics Pvt.Ltd.";

  UserRoleFinance: string = 'FINANCE';
  UserRoleAccounts: string = 'ACCOUNTS';
  UserRoleHR: string = 'HRPROFILE';
  UserKockpitRole: string = 'KOCKPIT';
  ExperienceType: string = 'Fresher';
  UserRoleBUHead: string = 'BUHEAD';
  UserTravelDesk: string = 'TRAVELDESK';
  UserCFORole: string = 'CFO';

  /** Only these TMC IDs can access Driver Reimbursement → Manager Approval Inbox */
  driverManagerApprovalTmcIds: string[] = environment.driverManagerApprovalTmcIds || [];

  isDriverManagerApprovalUser(tmcId?: string | null): boolean {
    if (!tmcId || !this.driverManagerApprovalTmcIds.length) {
      return false;
    }
    const normalized = String(tmcId).trim().toUpperCase();
    return this.driverManagerApprovalTmcIds
      .map(id => String(id).trim().toUpperCase())
      .includes(normalized);
  }

  /** Off-role TMCs use TA / TRE / APP prefixes (same as local travel). */
  isOffRoleTmc(tmc: any): boolean {
    if (tmc == null || tmc === '') {
      return false;
    }
    const value = String(tmc).toUpperCase();
    return value.indexOf('TRE') !== -1 || value.indexOf('APP') !== -1 || value.indexOf('TA') !== -1;
  }

  //#region Global Variales
  UserId: string = null;
  UserName: string = null;
  ReportingID: string = null;
  UserRole: string = null;

  private subject = new Subject<any>();
  //#endregion
  driverData: any[] = [];
  constructor(private crudService: CrudService) {
    this.UserId = sessionStorage.getItem('userId');
    this.ReportingID = sessionStorage.getItem('ReportingID');
    this.UserName = sessionStorage.getItem("");

  }

  MediaUploadURL(urlString): string {
    return this.crudService.siteUrl + '/' + urlString.substr(urlString.indexOf("UploadedFiles"));
  }

  datecompare(date1, sign, date2) {
    var day1 = date1.getDate();
    var mon1 = date1.getMonth();
    var year1 = date1.getFullYear();
    var day2 = date2.getDate();
    var mon2 = date2.getMonth();
    var year2 = date2.getFullYear();
    if (sign === '===') {
      if (day1 === day2 && mon1 === mon2 && year1 === year2) return true;
      else return false;
    }
    else if (sign === '>') {
      if (year1 > year2) return true;
      else if (year1 === year2 && mon1 > mon2) return true;
      else if (year1 === year2 && mon1 === mon2 && day1 > day2) return true;
      else return false;
    }
  }
  SwalSuccessMsg(msg: string) {
    Swal.fire({
      toast: true, title: msg,
      icon: 'success', position: 'top',
      width: 350, timer: 4000,
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

  }
  SwalErrorMsg(msg: string) {
    Swal.fire({
      toast: true,
      title: msg,
      icon: 'error',
      position: 'top',
      width: 350,
      timer: 4000,
      showConfirmButton: false,
      timerProgressBar: true,

      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

  }

  findUnique(arr, predicate) {
    var found = {};
    arr.forEach(d => {
      found[predicate(d)] = d;
    });
    return Object.keys(found).map(key => found[key]);
  }
  GetCompleteLink(url: string): string {
    if (!url.toLowerCase().includes('http://') && !url.toLowerCase().includes('https://')) {
      return 'http://' + url;
    }
    return url;
  }

  getFormattedDate(date: any) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return year + '-' + month + '-' + day;
  }

    parseLocalDate(value: any): Date {
    if (value == null || value === '') {
      return value;
    }
    if (value instanceof Date) {
      return value;
    }
    if (typeof value === 'number') {
      return new Date(value);
    }

    const s = String(value).trim();

    // ISO yyyy-MM-dd (optionally with time) — build a local date, not UTC midnight.
    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (m) {
      return new Date(+m[1], +m[2] - 1, +m[3]);
    }

    // dd/MM/yyyy, dd-MM-yyyy, dd.MM.yyyy
    m = /^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})/.exec(s);
    if (m) {
      return new Date(+m[3], +m[2] - 1, +m[1]);
    }

    return new Date(s);
  }

  toYmdLocal(value: any): string {
    const d = this.parseLocalDate(value);
    if (!d || typeof d.getFullYear !== 'function' || isNaN(d.getTime())) {
      return value;
    }
    return this.getFormattedDate(d);
  }

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  setUserData(userdata: any) {
    this.subject.next({ UserData: userdata });
  }

  getUserData(): Observable<any> {
    return this.subject.asObservable();
  }

  getUserDataTHR(): Observable<any> {
    return this.subject.asObservable();
  }

  setUserDataTHR(userdataTHR: any) {
    this.subject.next({ UserDataTHR: userdataTHR });
  }

  getMasterData() {
    return this.crudService.get<any>('Master/GetMasterDetails');
  }

  // getFareMasterData() {
  //   return this.crudService.get<any>('Master/GetFareMasterDetails');
  // }
  getFareMasterData(BranchCode: string) {
    return this.crudService.get<any>('Master/GetFareMasterDetails?BranchCode=' + BranchCode);
  }

  getCurrentVersion() {
    return this.crudService.get<any>('Master/GetVersion');
  }

  // fetchAllCustomerListPromise(){
  //   return this.crudService.get<any>('Master/GetCustomerMasterDetails').toPromise();
  // }
  fetchAllCustomerListPromiseTravel(Name: string) {
    return this.crudService.get<any>('Master/GetCustomerMasterDetailsTravel?Name=' + Name).toPromise();
  }
  getCustomerListObservableTravel(Name: string): Observable<any> {
    return this.crudService.get<any>('Master/GetCustomerMasterDetailsTravel?Name=' + Name);
  }

  checkProperty(x) {
    if (x == null) {
      return true;
    }

    else if (x === null) {
      return true;
    }

    else if (typeof x === 'undefined') {
      return true;
    }
    else if (x == '') {
      return true;
    }
    else {
      return false;
    }
  }

  GetRoleList() {
    return [
      { MASTER_VALUE: 'ADMIN' },
      { MASTER_VALUE: 'APPROVER' },
      { MASTER_VALUE: 'CHECKER' },
      { MASTER_VALUE: 'VISITOR' },
      { MASTER_VALUE: 'DELEGATE PIC' }
    ];
  }

  ValidateImage(fileName: string): boolean {
    var validExtensions = ['jpg', 'png', 'jpeg']; //array of valid extensions
    var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
    return validExtensions.includes(fileNameExt.toLowerCase());
  }

  WindowScroll(size: any) {
    window.scrollBy(0, size);
  }
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    sanitize: false
  };

}
